<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col>
        <card-page :card-title="cardTitle">
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
            class="mt-8"
            ref="form"
            :model="model"
            :options="formOptions"
            :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import FormModelMixin from '@/components/mixins/FormModelMixin';
import FormFieldValidationMixin from '@/components/mixins/FormFieldValidationMixin';
import {
  selectOptions,
  datepickerOptions
} from '@/components/form/FormElementOption';
import moment from 'moment';
import CardPage from '../../../../components/Views/CardPage';

export default {
  name: 'SectionForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    CardPage
  },
  mixins: [FormModelMixin, FormFieldValidationMixin],
  data() {
    return {
      selectedReferences: [],
      model: {
        Product_FK: null,
        PrintIssueSystem_FK: null,
        PrintIssueMethod_FK: null
      },
      schema: {
        groups: [
          {
            styleClasses: 'grid grid-cols-3',
            fields: [
              {
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: '',
                label: 'Product',
                model: 'Product_FK',
                values: () => this.products,
                selectOptions,
                required: true,
                validator: 'required'
              },
              {
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: '',
                label: 'Print Issue system',
                model: 'PrintIssueSystem_FK',
                values: () => this.printIssueSystem,
                selectOptions,
                required: true,
                validator: ['required']
              },
              {
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: '',
                label: 'Print Issue Method',
                model: 'PrintIssueMethod_FK',
                values: () => this.printIssueMethod,
                selectOptions,
                required: true,
                validator: ['required']
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      products: [],
      printIssueSystem: [],
      printIssueMethod: [],
      options: [
        {
          endpoint: () => this.$api.products.list({ params: { all: true, includeOwner: true } }),
          optionsFieldName: 'products',
          nameFieldName: 'ProductCode',
          idFieldName: 'Product_FK',
          modelArrayName: 'products'
        },
        {
          endpoint: () => this.$api.facilities.sections.printIssueSystem.list(),
          optionsFieldName: 'printIssueSystem',
          nameFieldName: 'TypeName',
          idFieldName: 'PrintIssueSystem_FK',
          modelArrayName: 'products'
        },
        {
          endpoint: () => this.$api.facilities.sections.printIssueMethod.list(),
          optionsFieldName: 'printIssueMethod',
          nameFieldName: 'TypeName',
          idFieldName: 'PrintIssueMethod_FK',
          modelArrayName: 'products'
        }
      ]
    };
  }
};
</script>
